<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <div class="d-flex" style="padding-bottom: 36px">
          <h3 class="text-inherit">My Groups</h3>
          <router-link :to="{ name: 'create-forum-group' }" class="ml-auto">
            <button
              class="d-flex align-items-center btn btn-primary w-100 edit-button d"
            >
              <img src="../assets/add.svg" class="mr-2" />
              Create New Group
            </button>
          </router-link>
        </div>

        <h5 class="text-inherit" v-if="groupInvites.length">Pending Invites</h5>

        <ul v-if="groupInvites.length" class="list-style-none mb-5">
          <li class="my-2" v-for="group in groupInvites" :key="group.id">
            <div
              class="request-container p-2 d-flex justify-content-between align-items-center my-3"
            >
              <h5 class="text-inherit m-0">{{ group.name }}</h5>
              <div>
                <button
                  :ref="'acceptinvite-' + group.id"
                  @click="acceptInvite(group.id)"
                  class="btn btn-outline mx-1 btn-primary"
                >
                  Accept Invite
                </button>
                <button
                  :ref="'rejectinvite-' + group.id"
                  @click="rejectInvite(group.id)"
                  class="btn btn-outline mx-1 btn-danger"
                >
                  Decline Invite
                </button>
              </div>
            </div>
          </li>
        </ul>

        <h5 class="text-inherit" v-if="joinedGroups.length">
          Joined Groups
        </h5>

        <table style="width: 100%">
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th></th>
          </tr>
          <tr v-for="group in joinedGroups" :key="group.id">
            <td>
              <router-link :to="'/forum/group/' + group.id">{{
                group.name
              }}</router-link>
            </td>

            <td>{{ group.role }}</td>

            <td>
              <button
                class="btn dropdown-btn"
                type="button"
                :id="'dropdownMenuButton' + group.id"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="material-icons p-0">arrow_drop_down</i>
              </button>

              <div
                class="dropdown-menu"
                :aria-labelledby="'dropdownMenuButton' + group.id"
              >
                <a
                  v-if="group.role === 'Creator' || group.role === 'Moderator'"
                  class="dropdown-item"
                  :href="'/forum/edit/' + group.id"
                >
                  Manage Group
                </a>
                <a
                  class="dropdown-item"
                  href="javascript:void(0)"
                  @click="leaveGroup(group)"
                >
                  Leave Group
                </a>
              </div>
            </td>
          </tr>
        </table>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import UserMenu from "../components/UserMenu";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";

export default {
  name: "MyGroups",
  components: {
    UserMenu,
    CommunityCard,
    Footer,
  },
  created() {
    this.loadData();
  },
  data: function () {
    return {
      groups: [],
      isSubmitting: false,
    };
  },
  computed: {
    joinedGroups() {
      return this.groups.filter((g) => g.status === "Joined");
    },
    groupInvites() {
      return this.groups.filter((g) => g.status === "Invited");
    },
  },
  methods: {
    loadData() {
      forumGroupService.myGroupsWithStatus().then((data) => {
        this.groups = data;
      });
    },
    acceptInvite(groupId) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["acceptinvite-" + groupId][0];
      btn.innerHTML = "...";

      forumGroupService
        .acceptInvite(groupId)
        .then(() => {
          this.showSuccess("You joined the group");
        })
        .finally(() => {
          this.loadData();
          this.isSubmitting = false;
          btn.innerHTML = "Accept Invite";
        });
    },
    rejectInvite(groupId) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["rejectinvite-" + groupId][0];
      btn.innerHTML = "...";

      forumGroupService
        .rejectInvite(groupId)
        .then(() => {
          this.showSuccess("You didn't join the group");
        })
        .finally(() => {
          this.loadData();
          this.isSubmitting = false;
          btn.innerHTML = "Decline Invite";
        });
    },
    leaveGroup(groupObj) {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });

      if (groupObj.role === "Creator" || groupObj.role === "Owner") {
        swalWithBootstrapButtons.fire({
          title: "Invalid",
          html: "You may not leave a group you created.",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok",
        });

        return;
      }

      swalWithBootstrapButtons
        .fire({
          title: "Leave " + groupObj.name + "?",
          html: "You may not be able to join again without permission.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Leave Group",
        })
        .then((result) => {
          if (result.value) {
            forumGroupService.leaveGroup(groupObj.id).then((data) => {
              this.showSuccess("You left the group.");
              this.loadData();
            });
          }
        });
    },
    showSuccess(msg) {
      vm.$swal
        .mixin({
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          buttonsStyling: false,
        })
        .fire("Success!", msg, "success");
    },
  },
};
</script>

<style scoped>
tr {
  border-top: 1px solid #eceeef;
  height: 40px;
}

th {
  padding-left: 16px;
}

td {
  padding-left: 16px;
  width: 30%;
}
td:last-child {
  width: 5%;
}

.dropdown-btn {
  background: none;
  border: 2px solid #599ed8;
  border-radius: 4px;
  padding: 2px;
  height: 32px;
  width: 32px;
}

.material-icons {
  color: #599ed8;
}

.request-container {
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
